module.exports = __webpack_public_path__ + "img/logo-rackon2-w-contorno-eq.f56d2d40.svg";